import { Component, OnInit } from "@angular/core";
import { MessageService } from "primeng/api";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import {
  NonIndividualRelationshipEntry,
  PlanActionEntry,
  QualityGateFilter,
  QualityGateSubmission,
  RelationshipToIssuer,
} from "src/api/models";
import { QualityGateService } from "src/api/services";
import { preventLeadingSpaceKey } from "src/core/utils/input-validation.utils";

@Component({
  selector: "app-non-individual-relationship-processed",
  // imports: [],
  templateUrl: "./processed.component.html",
  styleUrl: "./processed.component.css",
  standalone: false,
})
export class NonIndividualRelationshipProcessedComponent implements OnInit {
  ref!: DynamicDialogRef;
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  selectedTag: any[] = [];
  first = 0;
  rows = 10;
  isLoading: boolean = false;
  issuerName?: string;
  filingId?: number;
  insiderName?: string;
  processedNonIndividualRelationshipEntries: NonIndividualRelationshipEntry[] =
    [];

  relationshipOptions: { label: string; value: string }[] = [];
  constructor(
    private _qualityGateService: QualityGateService,
    public dialogService: DialogService,
    private _messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.relationshipOptions = RelationshipToIssuer.values().map((v) => ({
      label: v,
      value: v,
    }));
  }

  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  loadData(event: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;
    this.getProcessedNonIndividualEntries();
  }

  onUpdateClick(share: NonIndividualRelationshipEntry) {
    if (share.issuerRelationship?.trim()) {
      this.submitRelationship(share, share.issuerRelationship.trim());
    } else {
      this._messageService.add({
        severity: "warn",
        summary: "Missing Relationship",
        detail: "Please select a relationship before updating.",
      });
    }
  }

  submitRelationship(
    share: NonIndividualRelationshipEntry,
    relationship: string
  ) {
    const submission: QualityGateSubmission = {
      qualityGateType: "Non_Individual_relationship",
      missingSharesSubmission: {
        entryId: 0,
        indeterminable: false,
      },
      transactionTypeOtherSubmission: {
        entryId: 0,
        updatedTransactionType: "",
      },
      transactionTypeBuySubmission: {
        entryId: 0,
      },
      missingSecurityBreakDownSubmission: {
        entryId: 0,
      },
      aggregateSharesValidationSubmission: {
        entryId: 0,
        indeterminable: false,
      },
      transactionTagsSubmission: {
        entryId: 0,
      },
      transactionTypeNullSubmission: {
        entryId: 0,
      },
      securityTypeNullSubmission: {
        entryId: 0,
      },
      nonIndividualRelationshipSubmission: {
        entryId: share.entryId ?? 0,
        relationShip: relationship,
      },
    };

    this._qualityGateService.submit(submission).subscribe({
      next: (response) => {
        this._messageService.add({
          severity: "success",
          summary: "Submission Successful",
          detail: "The record has been excluded successfully.",
        });
        // reset original relationship so button disables again
        (share as any).originalRelationship = relationship;
        this.getProcessedNonIndividualEntries();
      },
      error: (err) => {
        this._messageService.add({
          severity: "error",
          summary: "Submission Failed",
          detail: err?.error?.message || "An error occurred while submitting.",
        });
      },
    });
  }

  onSearch() {
       const fid = String(this.filingId ?? '').trim();
  if (fid && !/^\d+$/.test(fid)) {
    return;
  }
    this.first = 0;
    this.paginator.pageNumber = 1;
    this.getProcessedNonIndividualEntries();
  }
  preventSpaceKey(event: KeyboardEvent): void {
      preventLeadingSpaceKey(event);
    }
  getProcessedNonIndividualEntries() {
    const params: QualityGateFilter = {
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      processStatus: "PROCESSED",
      qualityGateType: "Non_Individual_relationship",
      issuerName: this.issuerName,
      insiderName: this.insiderName,
      filingId: this.filingId,
    };
    this.isLoading = true;
    this._qualityGateService.view(params).subscribe({
      next: (value) => {
        this.processedNonIndividualRelationshipEntries = (
          value.nonIndividualEntries ?? []
        ).map((entry) => {
          // add UI-only field dynamically
          return {
            ...entry,
            originalRelationship: entry.issuerRelationship,
          } as any;
        });
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.processedNonIndividualRelationshipEntries?.[0]?.totalCount ?? 0;
        this.isLoading = false;
      },
    });
  }
}
